import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getAdminUser, updateAdminRole } from '../../services/adminManagementServices';
import { AppDispatch } from '../../core/data/redux/store';
import { Breadcrumb, Card, Button, Tag, Typography, Form, Select, Space, message, Row, Col } from 'antd';

const { Title, Text, Paragraph } = Typography;
const { Option } = Select;

const UpdateAdminRole = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { adminUser, isLoading, isError, errorMessage } = useSelector((state: any) => state.adminManagement);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (id) {
      dispatch(getAdminUser(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (adminUser) {
      form.setFieldsValue({ role: adminUser.role });
    }
  }, [adminUser, form]);

  const onFinish = (values: any) => {
    if (id) {
      setUpdateLoading(true);
      dispatch(updateAdminRole({ user_id: id, role: values.role }, () => {
        setUpdateLoading(false);
        message.success('Role updated successfully');
        navigate(`/admin/admin-management/admin-detail/${id}`);
      }));
    }
  };

  if (isLoading) return <Card loading style={{ margin: 24 }} />;
  if (isError) return <Card style={{ margin: 24 }}><Text type="danger">{errorMessage}</Text></Card>;
  if (!adminUser) return <Card style={{ margin: 24 }}><Text>Admin user not found</Text></Card>;

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management">Admin Management</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management/list-admins">List Admins</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Update Role</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Update Admin Role</Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Title level={5}>Current User Information</Title>
              <Paragraph><Text strong>Username:</Text> {adminUser.username}</Paragraph>
              <Paragraph><Text strong>Full Name:</Text> {adminUser.full_name}</Paragraph>
              <Paragraph>
                <Text strong>Current Role:</Text> <Tag color={adminUser.role === 'SUPER_ADMIN' ? 'red' : adminUser.role === 'ADMIN' ? 'gold' : 'blue'}>{adminUser.role}</Tag>
              </Paragraph>
            </Col>
          </Row>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ marginTop: 24 }}
          >
            <Form.Item
              name="role"
              label="New Role"
              rules={[{ required: true, message: 'Please select a role' }]}
            >
              <Select>
                <Option value="USER">User</Option>
                <Option value="ADMIN">Admin</Option>
                <Option value="SUPER_ADMIN">Super Admin</Option>
              </Select>
            </Form.Item>
            <div style={{ marginBottom: 16 }}>
              <Card type="inner" style={{ background: '#f6ffed' }}>
                <Title level={5}>Role Permissions:</Title>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  <li><b>User:</b> Basic user permissions</li>
                  <li><b>Admin:</b> Administrative permissions</li>
                  <li><b>Super Admin:</b> Full system access</li>
                </ul>
              </Card>
            </div>
            <Form.Item style={{ textAlign: 'right' }}>
              <Link to="/admin/admin-management/list-admins">
                <Button style={{ marginRight: 8 }}>Cancel</Button>
              </Link>
              <Button type="primary" htmlType="submit" loading={updateLoading || isLoading} disabled={form.getFieldValue('role') === adminUser.role}>
                Update Role
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default UpdateAdminRole; 